module.exports = __webpack_public_path__ + "static/media/dcs003.68915f8b.png";